import { SimpleCheckList } from '@components'

import { SectionMessage, Space, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getImgPath } from '../../../../../../utils/getImgPath'
import { checkPointsTranslationKeys } from '../../constants/checkPointsTranslationKeys'
import * as Styled from './styles'

export const ModalBody = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <>
      <SectionMessage variant="warning" showIcon={false}>
        <Text>{t('approve_invoice_modal.section_message')}</Text>
      </SectionMessage>
      <Space size="s24" />
      <Text variant="bodyLG" weight="medium" alignment="center">
        {t('approve_invoice_modal.check_points.heading')}
      </Text>
      <Space size="s16" />
      <Styled.CheckPointsListAndImageWrapper>
        <SimpleCheckList items={checkPointsTranslationKeys} alignment="left" />
        <Styled.ModalImage
          src={getImgPath('/modals/security-shield-illustration.svg')}
          width="118"
          height="118"
          alt="security shield"
        />
      </Styled.CheckPointsListAndImageWrapper>
      <Space size="s24" />
      <Text variant="bodyLG" weight="medium" alignment="center">
        {t('approve_invoice_modal.check_points.text_below')}
      </Text>
    </>
  )
}
